/**
 * @generated SignedSource<<38089654f53f7e8f10d249c84fd3bdb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutBuyerMessage_item$data = {
  readonly vertical: VerticalType | null;
  readonly " $fragmentType": "CheckoutBuyerMessage_item";
};
export type CheckoutBuyerMessage_item$key = {
  readonly " $data"?: CheckoutBuyerMessage_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBuyerMessage_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutBuyerMessage_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vertical",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "90c604f245c388c7a79cbeb2e7cc379c";

export default node;
